import { render, staticRenderFns } from "./PicCarousel.vue?vue&type=template&id=654a8382"
import script from "./PicCarousel.vue?vue&type=script&lang=js"
export * from "./PicCarousel.vue?vue&type=script&lang=js"
import style0 from "./PicCarousel.vue?vue&type=style&index=0&id=654a8382&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports